<div class="upload-container"
     matRipple
     (drop)="onDrop($event)"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave()"
     [class.dragging]="isDragging">
  <mat-icon aria-hidden="true">cloud_upload</mat-icon>
  <p>{{'client.documents.drag-drop' | translate}}</p>
  @if(multiple()){
  <input type="file" multiple (change)="onFileSelect($event)" hidden #fileInput />
  <button matButton="elevated" (click)="fileInput.click()">{{'client.documents.browse' | translate}}</button>
  }
  @else{
  <input type="file" (change)="onFileSelect($event)" [accept]="allowedFileExtensions" hidden #fileInput />
  <button matButton="elevated" (click)="fileInput.click()" [disabled]="files().length>0">{{'client.documents.browse' | translate}}</button>
  }
</div>
@if(multiple() && files().length){
<mat-list>
  @for(file of files();track $index){
  <mat-list-item>
    <mat-icon matListIcon>insert_drive_file</mat-icon>
    <h4 matLine>{{ file.name }}</h4>
  </mat-list-item>
  }
</mat-list>
}
